import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ApiService } from '@core/services/api';
import { HelpInteractionPayload } from '@model/support';

/**
 * Telemetria de deflexão da ajuda (D-HD40, cumpre a promessa da D-HD28):
 * todo desfecho de sugestão de artigo (resolveu, abriu chamado, sem
 * resultado, leu artigo) vira um evento em `support/help-interactions`.
 *
 * `registrar` NUNCA quebra a tela: a chamada já se inscreve sozinha e
 * engole qualquer erro (rede fora do ar, 401, 500). Isto é telemetria, não
 * parte do fluxo do usuário — perder um evento é aceitável, travar a
 * abertura de chamado ou a busca por causa dele não é.
 *
 * `enviarVoto` é a exceção: o voto "Este artigo ajudou?" é uma ação
 * explícita, e o painel só pode agradecer pelo registro depois da resposta
 * de sucesso (achado A1 da revisão Astra, 31/10/2026).
 */
@Injectable({ providedIn: 'root' })
export class HelpTelemetryService {
  private readonly api = inject(ApiService);

  registrar(payload: HelpInteractionPayload): void {
    this.api.support.postHelpInteraction(this.higienizar(payload)).pipe(
      catchError(() => of(undefined)),
    ).subscribe();
  }

  /** Mesmo payload higienizado de `registrar`; só envia na inscrição e propaga a falha. */
  enviarVoto(payload: HelpInteractionPayload): Observable<void> {
    return this.api.support.postHelpInteraction(this.higienizar(payload));
  }

  private higienizar(payload: HelpInteractionPayload): HelpInteractionPayload {
    return {
      ...payload,
      ...(payload.query ? { query: payload.query_kind === 'entity' ? '[busca de entidade]' : this.redigir(payload.query).slice(0, 150) } : {}),
      ...(payload.reason_text ? { reason_text: this.redigir(payload.reason_text).slice(0, 500) } : {}),
      ...(payload.route ? { route: payload.route.split(/[?#]/, 1)[0].replace(/^(\/painel\/assistente-ia\/enviar\/)[^/]+/, '$1:token') } : {}),
    };
  }

  private redigir(texto: string): string {
    return texto.trim()
      .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[dado removido]')
      .replace(/\b\d{3}\.\d{3}\.\d{3}-\d{2}\b|\b\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}\b/g, '[dado removido]')
      .replace(/(?:\+55\s*)?\(?\d{2}\)?[ .-]*\d{4,5}[ .-]*\d{4}\b|\b\d{8,}\b/g, '[dado removido]');
  }
}
